import React,{useState} from 'react';
import Typography from '@visa/vds/typography'
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import {PageHelper} from '../../../_helpers/PageHelper';
import {adminService} from '../../../services/admin.service';
import AccessRequestUserTable from './AccessRequestUserTable';
import AccessRequestOrganizationTable from './AccessRequestOrganizationTable';
import OrganizationAccessDialog from './OrganizationAccessDialog';
import UserAccessDialog from './UserAccessDialog';
import {GlobalAlertContext} from '../../../context/GlobalAlertContext';
import { AuthContext } from '../../../context/AuthContext';

function ManageAccessRequest(){
    const PAGE_SIZE = 10
    const [userFetched, setUserFetched] = useState(false);
    const [orgFetched, setOrgFetched] = useState(false);

    const [selectedOrganization,setSelectedOrganization] = useState(null);
    const [selectedUser,setSelectedUser] = useState(null);

    const [accessRequestOrgsData,setaccessRequestOrgsData] = useState(null);
    const [accessRequestUsersData,setAccessRequestUsersData] = useState(null);

    const [userTotalPages,setUserTotalPages] = useState(0)
    const [orgTotalPages,setOrgTotalPages] = useState(0)

    const handleOrganizationPageChange = async (page) => {
        setOrgFetched(false);
        let skipCount = PageHelper.GetSkipCount(PAGE_SIZE,page)
        const AccessOrg = await adminService.GetAccessRequestOrganizations(skipCount)
        setaccessRequestOrgsData(AccessOrg);
        setOrgTotalPages(PageHelper.GetTotalCountToPages(PAGE_SIZE,AccessOrg.totalCount));
        setOrgFetched(true);
    }

    const handleUsersPageChange = async (page) => {
        setUserFetched(false);
        let skipCount = PageHelper.GetSkipCount(PAGE_SIZE,page)
        const AccessUsers = await adminService.GetAccessRequestUsers(skipCount)
        setAccessRequestUsersData(AccessUsers);
        setUserTotalPages(PageHelper.GetTotalCountToPages(PAGE_SIZE,AccessUsers.totalCount));
        setUserFetched(true);
    }

    const tablesRefresh= async() =>{
        handleOrganizationPageChange(1);
        handleUsersPageChange(1);
    }

    React.useEffect(()=>{
        handleOrganizationPageChange(1);
        handleUsersPageChange(1);
    },[]);

    return (
    <GlobalAlertContext.Consumer>
        {
            alertObj=>(
                <AuthContext.Consumer>{
                    currentUser =>(
                        <>
                        <OrganizationAccessDialog alertObj={alertObj} tablesRefresh={tablesRefresh} organization={selectedOrganization} openOrgAccessDialog={selectedOrganization!= null} setSelectedOrganization={setSelectedOrganization} currentUser={currentUser}/>
                        <UserAccessDialog alertObj={alertObj} tablesRefresh={tablesRefresh} user={selectedUser} openUserAccessDialog={selectedUser!= null} setSelectedUser={setSelectedUser} currentUser={currentUser}/>
                        <Grid>
                            <Row>
                                <Col>
                                    <Typography tag="h1">Manage Access Requests</Typography>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Typography tag="h2">VSS Request: Organizations</Typography>
                                </Col>
                                <AccessRequestOrganizationTable  fetch={handleOrganizationPageChange} PAGE_SIZE={10} fetched={orgFetched} setSelectedOrganization={setSelectedOrganization} data={accessRequestOrgsData} totalPages={orgTotalPages}/>
                            </Row>
                
                            <Row>
                                <Col>
                                    <Typography tag="h2">VSS Request: Users</Typography>
                                </Col>
                                <AccessRequestUserTable PAGE_SIZE={10} fetch={handleUsersPageChange} fetched={userFetched} setSelectedUser={setSelectedUser} data={accessRequestUsersData} totalPages={userTotalPages} />
                            </Row>
                            
                        </Grid>
                        </>
                    )    
                }</AuthContext.Consumer>

            )
        }
    </GlobalAlertContext.Consumer>
    );
    
  }


export default ManageAccessRequest;
